/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './image-tests.reducer';

export const ImageTestsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const imageTestsEntity = useAppSelector(state => state.imageTests.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="imageTestsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.imageTests.detail.title">ImageTests</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.imageTests.id">Id</Translate>
            </span>
          </dt>
          <dd>{imageTestsEntity.id}</dd>
          <dt>
            <span id="category">
              <Translate contentKey="tinyMedicRestApp.imageTests.category">Category</Translate>
            </span>
          </dt>
          <dd>{imageTestsEntity.category}</dd>
          <dt>
            <span id="bodyPart">
              <Translate contentKey="tinyMedicRestApp.imageTests.bodyPart">Body Part</Translate>
            </span>
          </dt>
          <dd>{imageTestsEntity.bodyPart}</dd>
          <dt>
            <span id="modality">
              <Translate contentKey="tinyMedicRestApp.imageTests.modality">Modality</Translate>
            </span>
          </dt>
          <dd>{imageTestsEntity.modality}</dd>
          <dt>
            <span id="testName">
              <Translate contentKey="tinyMedicRestApp.imageTests.testName">Test Name</Translate>
            </span>
          </dt>
          <dd>{imageTestsEntity.testName}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.imageTests.active">Active</Translate>
            </span>
          </dt>
          <dd>{imageTestsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.imageTests.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{imageTestsEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.imageTests.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{imageTestsEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.imageTests.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{imageTestsEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.imageTests.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{imageTestsEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/image-tests" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/image-tests/${imageTestsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ImageTestsDetail;
